import { useEffect, useRef, useState } from "react";
import { getRemittanceInvoiceData } from "./api";

const useRemittanceInvoice = ({ remittanceId }) => {
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const invoiceRef = useRef(null);

  useEffect(() => {
    if (remittanceId) {
      setLoading(true);
      getRemittanceInvoiceData(remittanceId).then((response) => {
        setInvoice(response?.data?.data);
        setLoading(false);
      });
    }
  }, [remittanceId]);

  return {
    invoice,
    loading,
    invoiceRef,
  };
};

export default useRemittanceInvoice;
